exports.NeuralNetwork = require("./neuralnetwork").NeuralNetwork;
exports.crossValidate = require("./cross-validate");



//////////////////
// WEBPACK FOOTER
// ./node_modules/brainjs/lib/brain.js
// module id = 335
// module chunks = 4